import * as React from "react";
import {CSSProperties, StyleHTMLAttributes} from "react";
import BusyIndicator from "components/BusyIndicator/BusyIndicator";
import BusyFromPromise, {BusyState} from "components/BusyFromPromise/BusyFromPromise";
import ErrorPanel from "components/ErrorPanel/ErrorPanel";
import {Errors} from "components/DataBaseComponent/DataBaseComponent";

import styles = require("./style.less");
import KeyboardHandler, {Key} from "../KeyboardHandler/KeyboardHandler";

export interface DialogLayoutDispatchProps {
    close(): void;
}

export interface DialogLayoutCommonProps {
    title: string;
    titleIcon?: React.ReactNode;
    extraHeaderContent?: (alignmentClassName: string) => React.ReactNode;
    additionalActions?: React.ReactNode;
    secondaryActions?: React.ReactNode;
    errors: Errors;
    busy: BusyState;
    headerClassName?: string;
    children?: React.ReactNode;
}

interface DialogLayoutProps extends DialogLayoutCommonProps {
    actions: React.ReactNode;
    closeDialog(): void;
    children?: React.ReactNode;
}

export class DialogLayout extends React.Component<DialogLayoutProps> {
    render() {
        const keyboardRegistrations = [{key: Key.Esc, onKeyPressed: this.onEscKeyPressed}];
        return <div className={styles.layout}>
            <KeyboardHandler registrations={keyboardRegistrations} className={styles.dialogWrapper}>
                    <div className={this.props.headerClassName}>
                        <BusyFromPromise promise={this.props.busy}>
                            {(busy: boolean) => <BusyIndicator show={busy}/>}
                        </BusyFromPromise>
                        <div className={styles.title}>
                            {this.props.titleIcon && <div className={styles.titleIcon}>{this.props.titleIcon}</div>}
                            {this.props.title}
                        </div>
                        {this.props.extraHeaderContent && this.props.extraHeaderContent(styles.headerContentAlignment)}
                    </div>
                    {this.props.errors &&
                    <ErrorPanel message={this.props.errors.message} details={this.props.errors.details}/>}
                    <div className={styles.body}>
                        {this.props.children}
                    </div>
                    <div className={styles.actions}>
                        <div className={styles.secondaryActions}>
                            {this.props.additionalActions}
                        </div>
                        <div className={styles.primaryActions}>
                            {this.props.actions}
                        </div>
                    </div>
                </KeyboardHandler>
        </div>;
    }

    onEscKeyPressed = () => {
        if (this.props.closeDialog) {
            this.props.closeDialog();
            return true;
        }
        return false;
    }
}
